import * as React from 'react';
import { cn } from 'lib/utils';

export interface SemiBoldProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

export const SemiBold = ({ children, className, ...props }: SemiBoldProps) => {
  return (
    <span className={cn('font-semibold', className)} {...props}>
      {children}
    </span>
  );
};

export default SemiBold;
